import React from "react";
import { TitleUnderline } from "./TitleUnderline";
import { doubtQuotes, obstacles } from "../data/content";
export function Doubts() {
  return <section aria-labelledby="doubts-title" className="flex w-full flex-col justify-center bg-cream-deep text-espresso md:min-h-[calc(100svh-4rem)]" data-id="element-50" data-mp="330bylxis3vwl">
      <div className="mx-auto w-full max-w-7xl px-5 py-10 md:px-10 md:py-6 lg:py-[3vh]" data-id="element-51" data-mp="2t1w5xq43sekz">
        <div className="grid gap-12 md:grid-cols-12 md:gap-8 lg:gap-16" data-id="element-52" data-mp="2fb9codh43gwa">
          <div className="md:col-span-5" data-id="element-53" data-mp="2k1zg3l5z99oc">
            <h2 id="doubts-title" className="font-serif text-4xl font-medium leading-tight sm:text-5xl md:text-4xl lg:text-5xl" data-id="element-54" data-mp="2k30zqe1274ho">
              Sätze, die <TitleUnderline data-id="element-55" data-mp="2acfuw8usl3qb">Träume</TitleUnderline> klein machen.
            </h2>
            <p className="mt-4 max-w-md text-lg font-light leading-relaxed text-cocoa md:mt-3 md:text-base md:leading-snug lg:mt-4 lg:text-lg lg:leading-relaxed" data-id="element-56" data-mp="2aad8rzwrfuqv">
              Vielleicht hast Du einige davon schon gehört. Vielleicht sagst Du sie Dir inzwischen selbst.
            </p>
            <ul className="mt-8 space-y-4 md:mt-5 md:space-y-2.5 lg:mt-8 lg:space-y-4" data-id="element-57" data-mp="i1abeim0d83n">
              {doubtQuotes.map(quote => <li key={quote} className="font-serif text-2xl italic leading-snug text-bark md:text-lg lg:text-2xl" data-id="element-58" data-mp="s19hm8uygmdc">
                  „{quote}“
                </li>)}
            </ul>
          </div>

          <div className="md:col-span-7 lg:col-span-6 lg:col-start-7" data-id="element-59" data-mp="3vhgmujt0qro8">
            <h3 className="text-sm uppercase tracking-[0.2em] text-taupe md:text-xs lg:text-sm" data-id="element-60" data-mp="3vfnd2vn3zrc0">Und dazu kommt oft:</h3>
            <ul className="mt-4 divide-y divide-cream-line border-y border-cream-line md:mt-3 lg:mt-4" data-id="element-61" data-mp="925fzl5qtuvp">
              {obstacles.map(item => <li key={item} className="py-3 text-base font-light text-cocoa md:py-2 md:text-sm lg:py-3 lg:text-lg" data-id="element-62" data-mp="4a47mabp4oay">
                  {item}
                </li>)}
            </ul>
            <p className="mt-8 font-serif text-3xl leading-snug text-espresso md:mt-5 md:text-2xl lg:mt-8 lg:text-3xl" data-id="element-63" data-mp="37rw2bwh7vmcu">
              Das alles sagt nichts über Dein Können aus. Es zeigt nur, dass Dir bisher der richtige Weg gefehlt hat.
            </p>
          </div>
        </div>
      </div>
    </section>;
}